import { render } from "./ErrorDialog.vue?vue&type=template&id=6b591586&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import "./ErrorDialog.vue?vue&type=style&index=0&id=6b591586&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b591586"

export default script